import type { PropertyPortalBrandingResponse } from '@/shared/api';

export function formatLogoMetadata(branding: PropertyPortalBrandingResponse): string | null {
  if (!branding.hasLogo) return null;
  const type = branding.logoContentType === 'image/png' ? 'PNG' : 'JPEG';
  const size =
    branding.logoByteLength == null ? null : `${Math.round(branding.logoByteLength / 1000)} KB`;
  const dimensions =
    branding.logoWidth && branding.logoHeight
      ? `${branding.logoWidth} × ${branding.logoHeight} px`
      : null;
  return [type, dimensions, size].filter(Boolean).join(' · ');
}
